import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ServicesMainPage from "../pages/ServiceMainPage";
import Navbar from "../component/Navbar";
import Home from "../pages/Home";
import { Portfolio } from "../pages/Portfolio/Portfolio";
import Footer from "../component/Footer";
import PortfolioDetailed from "../pages/portfolioDetailedPages/PortfolioDetailed";
import ArtificialIntelligenceServices from "../pages/ArtificialIntelligenceServices";
import MobileAppSection from "../pages/MobileAppSection";
import WebDevelopmentServices from "../component/WebDevelopmentServices";
import GraphicDesign from "../component/GraphicDesign";
import DevOps from "../component/DevOps";
import { PortfolioTestimonial } from "../pages/Portfolio-Testimonial/PortfolioTestimonial";
import EnquiryForm from "../pages/Portfolio/EnquiryForm";
import { ViewOpenings } from "../pages/Portfolio/ViewOpenings";
import { Career } from "../pages/Career/Career";
import { BusinessDevelopment } from "../pages/BusinessDevelopment";
import TeamSection from "../pages/Team/Team/About";
import SoftwareQuailtyInsurance from "../component/SqInsurance";

function AppRouter() {
  return (
    <Router>
      <Navbar />
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="Home" element={<Home />} />
          <Route path="servicemainpage" element={<ServicesMainPage />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/service-page" element={<ServicesMainPage />} />
          <Route path="/contact-us" element={<EnquiryForm />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:id" element={<PortfolioDetailed />} />
          <Route path="web-development" element={<WebDevelopmentServices />} />
          <Route path="graphic-designing" element={<GraphicDesign />} />
          <Route path="business-devlopment" element={<BusinessDevelopment />} />
          <Route path="dev-ops" element={<DevOps />} />
          <Route path="contact-us" element={<EnquiryForm />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="About" element={<TeamSection />} />
          <Route path="SQInsurance" element={<SoftwareQuailtyInsurance />} />
          <Route
            path="/customers"
            element={<PortfolioTestimonial />}
          />
          <Route
            path="artificial"
            element={<ArtificialIntelligenceServices />}
          />
          <Route path="mobile-app" element={<MobileAppSection />} />
          <Route path="view-Opening" element={<ViewOpenings />} />
          <Route path="career" element={<Career />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default AppRouter;
